import { create } from 'zustand'

interface ReviewEntity {
  entityType: 'shipment' | 'shipment_item'
  shipmentId?: number
  shipmentItemId?: number
  orderId?: number
  info?: any
}

interface OrderState {
  activeTab: string
  searchQuery: string
  currentPage: number
  pageSize: number

  reviewEntity: ReviewEntity | null
  reviewData: any | null

  isReviewModalOpen: boolean
  isReviewViewModalOpen: boolean

  setActiveTab: (tab: string) => void
  setSearchQuery: (query: string) => void
  setCurrentPage: (page: number) => void

  openCreateReview: (
      entity: ReviewEntity,
      review?: any
    ) => void
  openViewReview: (entity: ReviewEntity, review: any) => void
  closeReviewModal: () => void
}

export const useOrderStore = create<OrderState>((set) => ({
  activeTab: 'CURRENT',
  searchQuery: '',
  currentPage: 1,
  pageSize: 10,

  reviewEntity: null,
  reviewData: null,

  isReviewModalOpen: false,
  isReviewViewModalOpen: false,

  setActiveTab: (tab) =>
    set(() => ({
      activeTab: tab,
      currentPage: 1,
    })),

  setSearchQuery: (query) =>
    set(() => ({
      searchQuery: query,
      currentPage: 1,
    })),

  setCurrentPage: (page) =>
    set(() => ({
      currentPage: page,
    })),

  openCreateReview: (entity, review = null) =>
    set(() => ({
      reviewEntity: entity,
      reviewData: review,
      isReviewModalOpen: true,
      isReviewViewModalOpen: false,
    })),

  openViewReview: (entity, review) =>
    set(() => ({
      reviewEntity: entity,
      reviewData: review,
      isReviewModalOpen: false,
      isReviewViewModalOpen: true,
    })),

  closeReviewModal: () =>
    set(() => ({
      isReviewModalOpen: false,
      isReviewViewModalOpen: false,
      reviewEntity: null,
      reviewData: null,
    })),
}))
